import PricingPreview from "./PricingPreview";

export default PricingPreview;



// WEBPACK FOOTER //
// ./src/components/PricingPreview/index.js